import { useState } from "react";

import Box from "ds/components/Box";
import useBlockNavigationModal from "hooks/useBlockNavigationModal";
import { Policy, PolicyEngineType, PolicyType } from "types/generated";

import PolicySimulation from "../../PolicySimulation";
import { ManagementStrategy } from "../../Settings/types";
import styles from "../styles.module.css";
import LoginPolicyDetailsBodyContent from "./Content";

type LoginPolicyDetailsBodyProps = {
  policy: Policy;
  initialBody: string;
  isLoginPolicyActive: boolean;
};

const LoginPolicyDetailsBody = ({
  policy,
  initialBody,
  isLoginPolicyActive,
}: LoginPolicyDetailsBodyProps) => {
  const [body, setBody] = useState(initialBody);
  const [policyEngineType, setPolicyEngineType] = useState<PolicyEngineType>(policy.engineType);
  const [isSimulationVisible, setIsSimulationVisible] = useState(false);
  const isBodyChanged = initialBody !== body;

  useBlockNavigationModal({
    isNavigationBlocked: isBodyChanged,
    onConfirm: () => {
      setBody(initialBody);
    },
  });

  const handleEditorChange = (value?: string) => {
    setBody(value || "");
  };

  return (
    <Box justify="stretch" className={styles.pageContent}>
      <LoginPolicyDetailsBodyContent
        body={body}
        handleEditorChange={handleEditorChange}
        policyEngineType={policyEngineType}
        setPolicyEngineType={setPolicyEngineType}
        policy={policy}
        isSimulationVisible={isSimulationVisible}
        isLoginPolicyActive={isLoginPolicyActive}
      />
      <PolicySimulation
        className={styles.simulationWrapper}
        policyId={policy.id}
        body={body}
        type={PolicyType.Login}
        engineType={policyEngineType}
        isSimulationVisible={isSimulationVisible}
        setIsSimulationVisible={setIsSimulationVisible}
        defaultAnalyticsProperties={{
          managementStrategy: isLoginPolicyActive
            ? ManagementStrategy.LOGIN_POLICY
            : ManagementStrategy.USER_MANAGEMENT,
        }}
      />
    </Box>
  );
};

export default LoginPolicyDetailsBody;
